import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchFeatureSettings } from "@app/redux/actions/settings";
import api from "@app/redux/api/base-api";

/**
 * Custom hook to fetch feature settings from the API and store them in Redux.
 * It fetches feature settings from API when the component is mounted, and dispatches
 * the settings to the Redux store.
 * @returns {void} - This hook does not return any value.
 */

const useGetFeatureSettings = (): void => {
    const dispatch = useDispatch();

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const response = await api.get("/feature-toggle-settings/");
                if (response) {
                    dispatch(fetchFeatureSettings(response.data));
                }
            } catch (error) {
                console.log("Error fetching feature settings", error);
            }
        };
        fetchSettings();
    }, [dispatch]);
};

export default useGetFeatureSettings;
